/*
 * @Author: your name
 * @Date: 2020-02-18 18:47:15
 * @LastEditTime: 2024-04-25 14:02:41
 * @LastEditors: jwk 1450234096@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \merchant-ui-pc\src\services\query.js
 */
import request from "@/utils/request";

export function getLogList(query) {
  return request({
    url: "/api/merchant/business/log/login-log",
    method: "get",
    params: query
  });
}

export function getWhiteList(query) {
  return request({
    url: "/api/merchant/business/white-list",
    method: "get",
    params: query
  });
}

export function openWhiteList(query) {
  return request({
    url: "/api/merchant/business/white-list/open-or-close",
    method: "post",
    data: query
  });
}

export function getContactsList(query) {
  return request({
    url: "/api/merchant/contact/getContacts",
    method: "get",
    params: query
  });
}
// 新增/编辑接收人
export function addContact(data) {
  let url = data.id
    ? "/api/merchant/contact/editContact"
    : "/api/merchant/contact/addContact";
  return request({
    url,
    method: "post",
    params: data
  });
}

export function deleteContact(data) {
  return request({
    url: "/api/merchant/contact/removeContact",
    method: "post",
    params: data
  });
}

export function changeContactStatus(data) {
  return request({
    url: "/api/merchant/contact/changeContactStatus",
    method: "post",
    params: data
  });
}

export function checkAccount(data) {
  return request({
    url: "/api/merchant/business/admin/checkContactExist",
    method: "post",
    params: data
  });
}



// WEBPACK FOOTER //
// ./src/services/security.js